import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton } from "react-bootstrap";
import { useState, useEffect} from "react";
import {useLocation } from 'react-router-dom';
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {GetTableauUserCheckboxInputData,  GetTableauUserSelectInputData, GetTableauUserRadioInputData } from 'Containers/Private/Tableau/TableauUserFields';
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import { useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { TextButton } from "Components/Button";
import { formatDocDate, getDocumentDownloadCall, getDocumentPublicInfo } from "Utils/utilityFunctions";
import { ICONS } from "Utils/icons";
import { Icon0Square } from "react-bootstrap-icons";

const ArticleCardLink = ({groupId, image, imageAlt, cardTitle, text, isVideo, action, bg, classes, imgVariant,imgHeight, isExternal, tabIndex}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    
    const [isLoading, setIsLoading] = useState(true);
    const [filename, setFilename] = useState(null);
    const [link, setLink] = useState(null);

    const [date, setDate] = useState(null);
    const [title, setTitle] = useState(cardTitle);

    useEffect(() => {
        if(groupId != null){
            //loadFormData();
            
        }
        else{
            
        }
        
    }, []);

    

    

    return (

        <Card variant="article-card" bg={bg != null ? bg : ""} className={classes!=null ? " article-card h-100 " + classes: "article-card h-100"} as={Button} role="button" tabIndex={tabIndex} onClick={(e)=>{
            //console.log(e);
            action();
        }}>
            <div className={isVideo != null && isVideo == true ? "card-con video" : "card-con"}>
                <Card.Img height={imgHeight} variant={imgVariant!=null ? imgVariant : "top"} src={image} alt={imageAlt}></Card.Img>
            </div>
            <Card.Body className="p-4">
                <Card.Title ><span className="me-1">{title}</span>{isExternal!=null && isExternal==true ? <ICONS.launch/> : null}</Card.Title>
                <Card.Text>{text}</Card.Text>
                <Card.Footer className="p-0 mt-auto">{date!=null ? date : null}</Card.Footer>
            </Card.Body>
            
        </Card>  
    )
}

export default ArticleCardLink;
